import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import Cookies from 'js-cookie';


const initialState = {
  companyInfo: {},
  procurementInfo: {},
  supplierDiversity: {},
  buyerId: null,
  accountType: '',
}

export const submitCompanyDetails = createAsyncThunk(
  'buyerFormData/submitCompanyDetails',
  async (companyInfo, { dispatch, rejectWithValue }) => {
    const token = Cookies.get('authToken');

    if (!token) {
      throw new Error('Token is missing');
    }

    try {
      const response = await axios.post(
        'https://sourceiq-login-dha8dahravh6eyet.eastus-01.azurewebsites.net/api/buyer/info',
        companyInfo,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const submitProcurementDetails = createAsyncThunk(
  'buyerFormData/submitProcurementDetails',
  async (procurementInfo, { dispatch, rejectWithValue }) => {
    const token = Cookies.get('authToken');

    if (!token) {
      throw new Error('Token is missing');
    }

    try {
      const response = await axios.post(
        'https://sourceiq-login-dha8dahravh6eyet.eastus-01.azurewebsites.net/api/buyer/procurement-role',
      
          procurementInfo,
        
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const submitDiversityDetails = createAsyncThunk(
  'buyerFormData/submitDiversityDetails',
  async (supplierDiversityObjectives, { dispatch, rejectWithValue }) => {
    const token = Cookies.get('authToken');

    if (!token) {
      throw new Error('Token is missing');
    }

    try {
      const response = await axios.post(
        'https://sourceiq-login-dha8dahravh6eyet.eastus-01.azurewebsites.net/api/buyer/supplier-diversity/objectives',
      
        supplierDiversityObjectives,
        
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const confirmBuyerRegistration = createAsyncThunk(
  'buyerFormData/confirmBuyerRegistration',
  async (userId, { rejectWithValue }) => {
    const token = Cookies.get('authToken');

    if (!token) {
      throw new Error('Token is missing');
    }

    try {
      const response = await axios.post(
        `https://sourceiq-login-dha8dahravh6eyet.eastus-01.azurewebsites.net/api/buyer/confirm-registration`,
        { userId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const saveCompanyInfoToStore = (companyInfo) => (dispatch) => {
  dispatch(saveCompanyInfo(companyInfo));
};

export const saveProcurementInfoToStore = (procurementInfo) => (dispatch) => {
  dispatch(updateProcurementInfo(procurementInfo));
};

export const saveDiversityInfoToStore = (diversityInfo) => (dispatch) => {
  dispatch(updateDiversityInfo(diversityInfo));
};
export const saveCommunicationPreferencesToStore = (communicationPreferencesInfo) => (dispatch) => {
  dispatch(updateCommunicationPreferencesInfo(communicationPreferencesInfo));
};

export const saveTeamInfoToStore = (teamInfo) => (dispatch) => {
  dispatch(updateTeamInfo(teamInfo));
};
const buyerFormDataSlice = createSlice({
  name: 'buyerFormData',
 initialState,
  reducers: {

    resetBuyerFormData: () => initialState,
    updateCompanyInfo: (state, action) => {
      state.companyInfo = action.payload?.company;
      state.buyerId = action.payload?._id || null;
      state.accountType = action.payload?.accountType || '';
    },
    saveCompanyInfo: (state, action) => {
      state.companyInfo = action.payload;
    },
    updateProcurementInfo: (state, action) => {
      state.procurementInfo = action.payload;
    },
    updateDiversityInfo: (state, action) => {
      state.supplierDiversity = action.payload;
    },
    updateCommunicationPreferencesInfo: (state, action) => {
      state.communicationPreferences = action.payload;
    },
    updateTeamInfo: (state, action) => {
      state.teamInfo = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitCompanyDetails.fulfilled, (state, action) => {
        state.companyInfo = action.payload;
        state.buyerId = action.payload?.company?._id || null;
        state.accountType = action.payload?.company?.accountType || '';
      })
      .addCase(submitProcurementDetails.fulfilled, (state, action) => {
        state.procurementInfo = action.payload;
      });
  },
});

export const { updateCompanyInfo, updateProcurementInfo, updateDiversityInfo, updateTeamInfo,  updateCommunicationPreferencesInfo, saveCompanyInfo, resetBuyerFormData, savePersonalInfoToStore } = buyerFormDataSlice.actions;
export default buyerFormDataSlice.reducer;
